import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@wds/modal';
import { Button } from '@wds/button';
import { T } from '@sm/intl';
import COPY from './SeatRequestCopy';

const NotAvailableModalContent = ({ onModalFinished, team }) => {
  const { email, firstName, lastName } = team.accountOwner;
  const emailLabel = firstName
    ? `${firstName}${lastName ? `\u00A0${lastName}` : ''}`
    : email;
  return (
    <>
      <Modal.Header header={<T desc={COPY.MODAL_TITLE_NOT_AVAILABLE} />} />
      <Modal.Body>
        <p>
          <T desc={COPY.NOT_AVAILABLE_DESC_1} />
        </p>
        <p>
          <T
            desc={COPY.NOT_AVAILABLE_DESC_2}
            values={{
              email: () => <a href={`mailto:${email}`}>{emailLabel}</a>,
            }}
          />
        </p>
      </Modal.Body>
      <Modal.Footer align="right">
        <Button onClick={onModalFinished}>
          <T desc={COPY.CLOSE_BUTTON} />
        </Button>
      </Modal.Footer>
    </>
  );
};

NotAvailableModalContent.propTypes = {
  onModalFinished: PropTypes.func.isRequired,
  team: PropTypes.shape({
    accountOwner: PropTypes.shape({
      email: PropTypes.string.isRequired,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

export default NotAvailableModalContent;
